<template>
    <div class="price-table">
        <p>&nbsp;</p>
        <table class="table table-hover">
            <tbody>
                <tr>
                    <td class="text-right" style="width: 22%">Harga Jual</td>
                    <td></td>
                    <td class="text-right" style="width: 20%">{{ form.price_sale | currency }}</td>
                    <td class="text-right" style="width: 20%">{{ form.price_sale2 | currency }}</td>
                    <td class="text-right" style="width: 20%">{{ form.price_sale3 | currency }}</td>
                </tr>
                <tr>
                    <td class="text-right">Diskon</td>
                    <td>
                        <small><i>{{ form.discount_percent }} %</i></small>
                    </td>
                    <td class="text-right">{{ form.discount | currency }}</td>
                    <td class="text-right">{{ form.discount2 | currency }}</td>
                    <td class="text-right">{{ form.discount3 | currency }}</td>
                </tr>
                <tr>
                    <td class="text-right">Harga setelah diskon</td>
                    <td>
                        <small></small>
                    </td>
                    <td class="text-right price-table-separator">{{ price_after_first_discount | currency }}</td>
                    <td class="text-right price-table-separator">{{ price_after_first_discount2 | currency }}</td>
                    <td class="text-right price-table-separator">{{ price_after_first_discount3 | currency }}</td>
                </tr>
                <tr>
                    <td class="text-right">Tambahan diskon</td>
                    <td><i>{{ form.discount_extra_percent }} %</i></td>
                    <td class="text-right">{{ form.discount_extra | currency }}</td>
                    <td class="text-right">{{ form.discount_extra2 | currency }}</td>
                    <td class="text-right">{{ form.discount_extra3 | currency }}</td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td class="text-right price-table-separator">{{ form.subtotal | currency }}</td>
                    <td class="text-right price-table-separator">{{ form.subtotal2 | currency }}</td>
                    <td class="text-right price-table-separator">{{ form.subtotal3 | currency }}</td>
                </tr>
                <tr>
                    <td class="text-right">Biaya Strategis Taman Depan</td>
                    <td></td>
                    <td class="text-right">{{ strategis1 | currency }}</td>
                    <td class="text-right">{{ strategis2 | currency }}</td>
                    <td class="text-right">{{ strategis3 | currency }}</td>
                </tr>
                <tr v-if="itemMaster.detail.land_type == 'HOOK STRATEGIS' || itemMaster.detail.land_type == 'HOOK NON STRATEGIS' ">
                    <td class="text-right">Kelebihan Tanah</td>
                    <td>
                        <small><i>{{ extended_lot }} m<sup>2</sup> x {{ extended_price | currency }}</i></small>
                    </td>
                    <td class="text-right">{{ extended_lot_price1 | currency }}</td>
                    <td class="text-right">{{ extended_lot_price2 | currency }}</td>
                    <td class="text-right">{{ extended_lot_price3 | currency }}</td>
                </tr>
                <tr>
                    <td class="text-right">PPH Final</td>
                    <td></td>
                    <td class="text-right">{{ pph_final1 | currency }}</td>
                    <td class="text-right">{{ pph_final2 | currency }}</td>
                    <td class="text-right">{{ pph_final3 | currency }}</td>
                </tr>
                <tr>
                    <td class="text-right">PPN Bangunan</td>
                    <td></td>
                    <td class="text-right">{{ ppn_bangunan1 | currency }}</td>
                    <td class="text-right">{{ ppn_bangunan2 | currency }}</td>
                    <td class="text-right">{{ ppn_bangunan3 | currency }}</td>
                </tr>
                <tr>
                    <td class="text-right">PPN Tanah</td>
                    <td></td>
                    <td class="text-right">{{ ppn_tanah1 | currency }}</td>
                    <td class="text-right">{{ ppn_tanah2 | currency }}</td>
                    <td class="text-right">{{ ppn_tanah3 | currency }}</td>
                </tr>
                <tr>
                    <td class="text-right">BPHTB</td>
                    <td></td>
                    <td class="text-right">{{ bbn1 | currency }}</td>
                    <td class="text-right">{{ bbn2 | currency }}</td>
                    <td class="text-right">{{ bbn3 | currency }}</td>
                </tr>
                <tr>
                    <td class="text-right">Biaya surat &amp; Adm</td>
                    <td></td>
                    <td class="text-right">{{ admin1 | currency }}</td>
                    <td class="text-right">{{ admin2 | currency }}</td>
                    <td class="text-right">{{ admin3 | currency }}</td>
                </tr>
                <tr>
                    <td class="text-right">Biaya lain-lain</td>
                    <td></td>
                    <td class="text-right">{{ lainLain1 | currency }}</td>
                    <td class="text-right">{{ lainLain2 | currency }}</td>
                    <td class="text-right">{{ lainLain3 | currency }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <th class="text-right">Harga Pengikatan</th>
                    <th></th>
                    <th class="text-right price-table-separator">{{ form.total | currency }}</th>
                    <th class="text-right price-table-separator">{{ form.total2 | currency }}</th>
                    <th class="text-right price-table-separator">{{ form.total3 | currency }}</th>
                </tr>
            </tfoot>
        </table>

        <div class="row">
            <div class="col-md-6">
                <div class="alert alert-success">
                    <table class="table">
                        <tbody>
                            <tr>
                                <td>Cara Pembayaran:</td>
                                <td colspan="2" class="text-right">
                                    <b>{{ form.payment_type }}</b>
                                </td>
                            </tr>
                            <tr>
                                <td>Harga NJOP Bangunan</td>
                                <td class="text-right">{{ njop_bangunan | currency }} x {{ building_area }} m<sup>2</sup></td>
                                <td class="text-right">{{ total_njop_bangunan | currency }}</td>
                            </tr>
                            <tr>
                                <td>Harga NJOP Tanah</td>
                                <td class="text-right">{{ njop_tanah | currency }} x {{ lot_area }} m<sup>2</sup></td>
                                <td class="text-right">{{ total_njop_tanah | currency }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="2" class="text-right">Total NJOP</th>
                                <th class="text-right">{{ total_njop | currency }}</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
            <div class="col-md-6">
                <div class="alert alert-success">
                    <table class="table">
                        <tbody>
                            <tr>
                                <td>Keterangan:</td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Harga Bangunan / m<sup>2</sup></td>
                                <td class="text-right">{{ building_price | currency }} x {{ building_area }} m<sup>2</sup></td>
                                <td class="text-right">{{ total_building_price | currency }}</td>
                            </tr>
                            <tr>
                                <td>Harga Tanah / m<sup>2</sup></td>
                                <td class="text-right">{{ lot_price | currency }} x {{ lot_area }} m<sup>2</sup></td>
                                <td class="text-right">{{ total_lot_price | currency }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="2" class="text-right">Harga Unit</th>
                                <th class="text-right" v-if="itemMaster.detail && itemMaster.detail.unit_price">{{ itemMaster.detail.unit_price | currency }}</th>
                                <th class="text-right" v-if="itemMaster.detail && !itemMaster.detail.unit_price">{{ 0 | currency }}</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
const {console} = window
export default {
    props: ['form', 'itemMaster'],
    watch: {
        // 'form.price_sale': function() {
        //     this.calculatePrice()
        // },
        // 'form.discount_percent': function() {
        //     this.calculatePrice()
        // },
        // 'form.discount_extra_percent': function() {
        //     this.calculatePrice()
        // },
        'form.subtotal3' : function() {
          if(this.form.seller_type) {
            if(this.form.seller_type.toLowerCase() == 'internal') {
              if(this.form.media.type) {
                if(this.form.media.type.toLowerCase() == 'personal') {
                  this.form.media.commission = parseFloat(this.form.media.commission_percent) /100 * parseFloat(this.form.subtotal3).toFixed(0)
                }
              }
            }
          }
        },
    },
    mounted() {
        this.calculatePrice()
    },
    methods: {
        calculatePrice() {
            // Price 1
            // try {
            //     this.form.discount = parseInt(parseFloat(
            //         this.form.price_sale *
            //         (this.form.discount_percent/100)).toFixed(0))
            // } catch {
            //     this.form.discount = 0
            // }
            //
            // try {
            //     this.form.discount_extra = parseInt(parseFloat(
            //         this.price_after_first_discount *
            //         (this.form.discount_extra_percent/100)).toFixed(0))
            // } catch {
            //     this.form.discount_extra = 0
            // }
            //
            try {
                this.form.subtotal = this.price_after_first_discount
                    - this.form.discount_extra
            } catch {
                this.form.subtotal = 0
            }

            this.form.total = this.form.subtotal

            // Price 3
            try {
                this.form.discount3 = parseInt(parseFloat(
                    this.form.price_sale3 *
                    (this.form.discount_percent/100)).toFixed(0))
            } catch {
                this.form.discount3 = 0
            }

            try {
                this.form.discount_extra3 = parseInt(parseFloat(
                    this.price_after_first_discount3 *
                    (this.form.discount_extra_percent/100)).toFixed(2))
            } catch {
                this.form.discount_extra3 = 0
            }

            try {
                this.form.subtotal3 = parseInt(parseFloat(
                    (this.form.total+3000000)/1.185
                ).toFixed(0))
            } catch {
                this.form.subtotal3 = 0
            } finally {
                if (!this.form.total) {
                    this.form.subtotal3 = 0
                }
            }

            try {
                this.form.detail_other_cost3[0].amount = parseInt(parseFloat(
                    this.form.subtotal3 * 0.025).toFixed(0))
            } catch {
                this.form.detail_other_cost3[0].amount = 0
            }

            try {
                this.form.detail_other_cost3[1].amount = parseInt(parseFloat(
                    this.form.subtotal3 * 0.11).toFixed(0))
            } catch {
                this.form.detail_other_cost3[1].amount = 0
            }

            try {
                this.form.detail_other_cost3[5].amount = parseInt(parseFloat(
                    (this.form.subtotal3 - 60000000) * 0.05).toFixed(0))
            } catch {
                this.form.detail_other_cost3[5].amount = 0
            } finally {
                if (this.form.detail_other_cost3[5].amount < 0) {
                    this.form.detail_other_cost3[5].amount = 0
                }
            }

            try {
                let total3 = this.form.subtotal3
                total3+= this.form.detail_other_cost3[0].amount
                total3+= this.form.detail_other_cost3[1].amount
                total3+= this.form.detail_other_cost3[5].amount
                this.form.total3 = parseInt(parseFloat(total3).toFixed(0))
            } catch {
                this.form.total3 = 0
            }

            try {
                this.itemMaster.detail.unit_price = this.form.subtotal3
                this.itemMaster.detail.total_lot_price = parseInt(parseFloat(
                    this.form.subtotal3 - this.total_building_price).toFixed(0))
                this.itemMaster.detail.lot_price = parseInt(parseFloat(
                    this.itemMaster.detail.total_lot_price / this.lot_area).toFixed(0))
            } catch {}

            // Price 2

            try {
                this.form.discount2 = parseInt(parseFloat(
                    this.form.price_sale2 *
                    (this.form.discount_percent/100)).toFixed(0))
            } catch {
                this.form.discount2 = 0
            }

            try {
                this.form.discount_extra2 = parseInt(parseFloat(
                    this.price_after_first_discount2 *
                    (this.form.discount_extra_percent/100)).toFixed(0))
            } catch {
                this.form.discount_extra2 = 0
            }

            try {
                this.form.detail_other_cost2[1].amount = parseInt(parseFloat(
                    this.total_building_price * 0.11).toFixed(0))
            } catch {
                this.form.detail_other_cost2[1].amount = 0
            }

            try {
                this.form.detail_other_cost2[2].amount = parseInt(parseFloat(
                    this.itemMaster.detail.total_lot_price * 0.11).toFixed(0))
            } catch {
                this.form.detail_other_cost2[2].amount = 0
            }

            try {
                this.form.subtotal2 = this.price_after_first_discount2
                    - this.form.discount_extra2
            } catch {
                this.form.subtotal2 = 0
            }

            try {
                this.form.detail_other_cost2[5].amount = parseInt(parseFloat(
                    (
                        (
                            this.form.subtotal2 +
                            this.form.detail_other_cost2[4].amount +
                            this.form.detail_other_cost2[0].amount +
                            this.extended_lot_price2
                        ) - 20000000
                    ) * 0.05
                ).toFixed(0))
            } catch {
                this.form.detail_other_cost2[5].amount = 0
            } finally {
                if (this.form.detail_other_cost2[5].amount < 0) {
                    this.form.detail_other_cost2[5].amount = 0
                }
            }

            try {
                if (this.itemMaster.type_id == 2) {
                    this.itemMaster.detail.lot_extra_total2 = 0
                }
                this.form.detail_other_cost2[6].amount = parseInt(parseFloat(
                    this.form.total -
                    this.form.subtotal2 -
                    this.strategis2 -
                    this.extended_lot_price2 -
                    this.pph_final2 -
                    this.ppn_bangunan2 -
                    this.ppn_tanah2 -
                    this.bbn2 -
                    this.admin2 -
                    0
                    // this.form.detail_other_cost2[4].amount -
                    // this.form.detail_other_cost2[0].amount -
                    // this.form.detail_other_cost2[1].amount -
                    // this.form.detail_other_cost2[2].amount -
                    // this.form.detail_other_cost2[5].amount -
                    // this.form.detail_other_cost2[3].amount
                ).toFixed(0))
            } catch {
                this.form.detail_other_cost2[6].amount = 0
            }

            try {
                this.form.total2 = parseInt(parseFloat(
                    this.form.subtotal2 +
                    this.strategis2 +
                    this.extended_lot_price2 +
                    this.pph_final2 +
                    this.ppn_bangunan2 +
                    this.ppn_tanah2 +
                    this.bbn2 +
                    this.admin2 +
                    this.lainLain2 +
                    0
                ).toFixed(0))
            } catch {
                this.form.total2 = 0
            }
        },
    },
    computed: {
        lot_area() {
            var value = 0
            try {
                value = parseFloat(this.itemMaster.detail.lot_area)
            } catch (e) {}
            if (!value) {
                try {
                    value = parseFloat(this.form.house_detail.lot_area)
                } catch (e) {}
            }
            return isNaN(value) ? 0 : value
        },
        lot_price() {
            var value = 0
            try {
                value = parseFloat(this.itemMaster.detail.lot_price)
            } catch (e) {}
            if (!value) {
                try {
                    value = parseFloat(this.form.house_detail.lot_price)
                } catch (e) {}
            }
            return isNaN(value) ? 0 : value
        },
        total_lot_price() {
            var value = 0
            try {
                value = parseFloat(this.itemMaster.detail.total_lot_price)
            } catch (e) {}
            if (!value) {
                try {
                    value = parseInt(parseFloat(this.lot_area).toFixed(0)) * parseInt(this.lot_price)
                } catch (e) {}
            }
            return isNaN(value) ? 0 : value
        },
        building_area() {
            var value = 0
            try {
                value = parseFloat(this.itemMaster.detail.building_area)
            } catch (e) {}
            if (!value) {
                try {
                    value = parseFloat(this.form.house_detail.building_area)
                } catch (e) {}
            }
            return isNaN(value) ? 0 : value
        },
        building_price() {
            var value = 0
            try {
                value = parseFloat(this.itemMaster.detail.building_price)
            } catch (e) {}
            if (!value) {
                try {
                    value = parseFloat(this.form.house_detail.building_price)
                } catch (e) {}
            }
            return isNaN(value) ? 0 : value
        },
        total_building_price() {
            var value = 0
            try {
                value = parseFloat(this.itemMaster.detail.total_building_price)
            } catch (e) {}
            if (!value) {
                try {
                    value = parseInt(parseFloat(this.building_area).toFixed(0)) * parseInt(this.building_price)
                } catch (e) {}
            }
            return isNaN(value) ? 0 : value
        },
        extended_lot() {
            var value = 0
            try {
                value = parseFloat(this.itemMaster.detail.extended_lot)
            } catch (e) {}
            if (!value) {
                try {
                    value = parseFloat(this.form.house_detail.extended_lot)
                } catch (e) {}
            }
            return isNaN(value) ? 0 : value
        },
        extended_price() {
            var value = 0
            try {
                value = parseFloat(this.itemMaster.detail.extended_lot_price)
            } catch (e) {}
            if (!value) {
                try {
                    value = parseInt(this.form.house_detail.extended_lot_price)
                } catch (e) {}
            }
            return isNaN(value) ? 0 : value
        },
        price_after_first_discount() {
            var self = this
            var value = 0
            try {
                value = parseInt(this.form.price_sale) - parseFloat(this.form.discount)
            } catch (e) {}
            self.form.price_after_discount = value
            return isNaN(value) ? 0 : value
        },
        price_after_first_discount2() {
            var self = this
            var value = 0
            try {
                value = parseInt(this.form.price_sale2) - parseFloat(this.form.discount2)
            } catch (e) {}
            self.form.price_after_discount2 = value
            return isNaN(value) ? 0 : value
        },
        price_after_first_discount3() {
            var self = this
            var value = 0
            try {
                value = parseInt(this.form.price_sale3) - parseFloat(this.form.discount3)
            } catch (e) {}
            self.form.price_after_discount3 = value
            return isNaN(value) ? 0 : value
        },
        strategis1() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost[4].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        strategis2() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost2[4].amount)
            } catch (e) {}
            if (!this.form.total) {
                return 0
            }
            return isNaN(value) ? 0 : value
        },
        strategis3() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost3[4].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        pph_final1() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost[0].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        pph_final2() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost2[0].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        pph_final3() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost3[0].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        ppn_bangunan1() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost[1].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        ppn_bangunan2() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost2[1].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        ppn_bangunan3() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost3[1].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        ppn_tanah1() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost[2].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        ppn_tanah2() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost2[2].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        ppn_tanah3() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost3[2].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        bbn1() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost[5].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        bbn2() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost2[5].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        bbn3() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost3[5].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        admin1() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost[3].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        admin2() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost2[3].amount)
            } catch (e) {}
            if (!this.form.total) {
                return 0
            }
            return isNaN(value) ? 0 : value
        },
        admin3() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost3[3].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        lainLain1() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost[6].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        lainLain2() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost2[6].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        lainLain3() {
            var value = 0
            try {
                value = parseInt(this.form.detail_other_cost3[6].amount)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        extended_lot_price1() {
            var value = 0
            try {
                value = parseInt(this.itemMaster.detail.lot_extra_total)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        extended_lot_price2() {
            var value = 0
            try {
                value = parseInt(this.itemMaster.detail.lot_extra_total2)
            } catch (e) {}
            if (this.itemMaster.type_id == 2) {
                return 0
            }
            return isNaN(value) ? 0 : value
        },
        extended_lot_price3() {
            var value = 0
            try {
                value = parseInt(this.itemMaster.detail.lot_extra_total3)
            } catch (e) {}
            return isNaN(value) ? 0 : value
        },
        njop_bangunan() {
            var value = 0
            var defaultValue = 1200000
            try {
                value = parseInt(this.itemMaster.detail.njop_bangunan)
            } catch (e) {
            }

            return isNaN(value) || !value ? defaultValue : value
        },
        njop_tanah() {
            var value = 0
            var defaultValue = 1274000
            try {
                value = parseInt(this.itemMaster.detail.njop_tanah)
            } catch (e) {
            }

            return isNaN(value) || !value ? defaultValue : value
        },
        total_njop_tanah() {
            var value = 0
            try {
                value = parseInt(this.itemMaster.detail.total_njop_tanah)
            } catch (e) {}

            if (isNaN(value) || !value) {
                try {
                    value = parseInt(this.njop_tanah * parseFloat(this.lot_area))
                } catch (e) {}
            }

            return isNaN(value) ? 0 : value
        },
        total_njop_bangunan() {
            var value = 0
            try {
                value = parseInt(this.itemMaster.detail.total_njop_bangunan)
            } catch (e) {}

            if (isNaN(value) || !value) {
                try {
                    value = parseInt(this.njop_bangunan * parseFloat(this.building_area))
                } catch (e) {}
            }

            return isNaN(value) ? 0 : value
        },
        total_njop() {
            var value = 0
            try {
                // console.log(this.itemMaster.detail.total_njop)
                value = parseInt(this.itemMaster.detail.total_njop)
            } catch (e) {}

            if (isNaN(value) || !value) {
                try {
                    value = this.total_njop_tanah + this.total_njop_bangunan
                } catch (e) {}
            }

            return isNaN(value) ? 0 : value
        },
        unit_price() {
            var value = 0
            try {
                value = parseInt(this.itemMaster.detail.unit_price)
            } catch (e) {}

            return isNaN(value) ? 0 : value
        },
    }
}
</script>

<style>
.price-table-separator {
    border-top: 2px dashed #c5c5c5 !important;
}
.price-table .table tr>td,
.price-table .table tr>th {
    /* border-top-width: 0px; */
    cursor: inherit;
}
</style>
